/**
 * Part of eden40 project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */

let menu = $('#page-menu');
let sectionTitle = $('.c-page-section-title');
let searchSection = $('.c-search-section');
let shareIcons = $('.c-share-icons');

if (menu.length) {
  menuInit();
}

searchInit();

function searchInit() {
  let html = '';

  html += '<i class="fa-solid fa-search"></i>';
  html += '<input id="j-search-input" class="form-control j-search-input" type="text" placeholder="搜尋" aria-label="搜尋"/>';

  searchSection.children('.c-addon__body').html(html);

  const input = ('.j-search-input');

  const textSection = $('.c-page-section-text').find('p');
  const search = $('#j-search-input');
  let canScroll;

  search.on('input', (e) => {
    const searchText = e.target.value;
    const regex = new RegExp(searchText, 'gi');

    clearTimeout(canScroll);

    canScroll = window.setTimeout(() => {
      textSection.each(function (i, e) {
        let text = e.innerText;
        let newText = '';

        if (!searchText) {
          newText = text.replace(regex, '$&');
        }

        if (searchText) {
          newText = text.replace(regex, '<span class="h-highlight">$&</span>');
        }

        e.innerHTML = newText;
      });

      $('html,body').animate({
        scrollTop: $($('.h-highlight')[0]).offset().top - ($('.c-header').height() + 50)
      }, 100);
    }, 1000);
  });
};

function menuInit() {
  let html = '';
  let text;

  sectionTitle.each((i, e) => {
    text = $(e).find('p').children('span').text();

    html += addMenuItem(text, i);
  });

  menu.html(html);

  let menuItem = $('.c-menu-item');

  menuItem.on('click', (e) => {
    const $this = $(e.currentTarget);
    const index = $this.data('target');
    const target = $(sectionTitle[index]);

    if ($this.hasClass('active')) {
      return;
    }

    $('html,body').animate({
      scrollTop: target.offset().top - ($('.c-header').height() + 50)
    }, 100);
  });

  $(window).on('scroll', () => {
    let rect = sectionTitle[0].getBoundingClientRect();
    let lastRect = sectionTitle[sectionTitle.length - 1].getBoundingClientRect();

    if (window.innerHeight - rect.top > (window.innerHeight * 0.5)
      && (window.innerHeight - lastRect.bottom) <= (window.innerHeight - 100)) {

      if (menu.hasClass('hide')) {
        menu.removeClass('hide');
      }
    } else {
      if (!menu.hasClass('hide')) {
        menu.addClass('hide');
      }
    }

    sectionTitle.each((i, e) => {
      const target = $(e);
      let rect = target[0].getBoundingClientRect();

      if (window.innerHeight - rect.top > (window.innerHeight * 0.4)
      ) {

        menuItem.removeClass('active');

        let active = '.c-menu-item[data-target = "' + i + '"]';

        $(active).addClass('active');
      }
    });
  });
}

function addMenuItem(text, index) {
  let html = '';

  html += '<div class="c-menu-item text-nowrap';

  if (index === 0) {
    html += ' active';
  }

  html += '" data-target="' + index + '" >';
  html += '<span>' + text + '</span></div>';

  return html;
}

shareIcons.children('.c-addon__body').html("<div class=\"addthis_toolbox\">\n" +
  "    <div class=\"custom_images d-flex justify-content-start align-items-center\">\n" +
  "        <div class=\"c-share-icon d-flex justify-content-center align-items-center line\">\n" +
  "            <a href=\"javascript://\" class=\"addthis_button_lineme mb-0\" title=\"分享至 Line\">\n" +
  "                <i class=\"fa-brands fa-line fa-fw\"></i>\n" +
  "                <span class=\"opacity-0 position-absolute\">分享至 Line</span>\n" +
  "            </a>\n" +
  "        </div>\n" +
  "\n" +
  "        <div class=\"c-share-icon d-flex justify-content-center align-items-center facebook\">\n" +
  "            <a href=\"javascript://\" class=\"addthis_button_facebook mb-0\" title=\"分享至 FB\">\n" +
  "                <i class=\"fa-brands fa-facebook-square fa-fw\"></i>\n" +
  "                <span class=\"opacity-0 position-absolute\">分享至 FB</span>\n" +
  "            </a>\n" +
  "        </div>\n" +
  "\n" +
  "        <div class=\"c-share-icon d-flex justify-content-center align-items-center\">\n" +
  "            <a href=\"javascript://\" class=\"j-copy-link mb-0\" title=\"複製連結\">\n" +
  "                <i class=\"fa-solid fa-link fa-fw\"></i>\n" +
  "                <span class=\"opacity-0 position-absolute\">複製連結</span>\n" +
  "            </a>\n" +
  "        </div>\n" +
  "    </div>\n" +
  "</div>");
